import axios from "~/plugins/axios";

export default {
  getTemporaryFile(temporaryFileId) {
    return axios.get(`/web_api/v1/temporary_file/${temporaryFileId}`).then((response) => response.data.data);
  },
  getTemporaryFileContents(temporaryFileId) {
    return axios.get(`/web_api/v1/temporary_file/${temporaryFileId}/contents`).then((response) => new Blob([response.data], { type: response.headers["content-type"] }));
  },
  uploadTemporaryFile(file){
    const formData = new FormData();
    formData.append("file", file);
    return axios.post("/web_api/v1/temporary_file", formData).then((response) => response.data);
  },
};
